<template>
	<div>
		<vue-tel-input v-model="value"
		               >
		</vue-tel-input>
	</div>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    import VueTelInput from 'vue-tel-input'

    export default {
        name: 'vfg-telephone',
        mixins: [ abstractField ],
        data () {
            return {

            }
        },
        methods: {
            reset () {
                this.value = '';
                this.startTime.time = '';
            }
        },
        components: {
            'vue-tel-input': VueTelInput
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

	.vue-tel-input .dropdown-toggle {
		position: absolute;
		width: 60px !important;
		z-index: 5;
	}
	.vue-tel-input .form-control {
		padding-left: 65px;
	}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldTelephone.vue